"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CONTACT_EMAIL: 'contactEmail',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  WEBSITE: 'website',
  PASSWORD: 'password',
  PASSWORD_CONFIRMATION: 'passwordConfirmation'
};
exports.default = _default;
module.exports = exports.default;